export const PAY_OPTION_ID_SBP = "sbp";
